import React from 'react';

const variants = {
  primary: 'bg-gradient-to-r from-red-600 to-red-500 text-white hover:from-red-700 hover:to-red-600 shadow-md hover:shadow-lg',
  secondary: 'bg-white/90 border-2 border-red-200 text-gray-800 hover:bg-red-50 hover:shadow-lg',
  dark: 'bg-gradient-to-r from-red-700 to-red-800 text-white hover:from-red-800 hover:to-red-900 shadow-md hover:shadow-lg',
  ghost: 'text-gray-700 hover:text-red-600',
};

const sizes = {
  sm: 'px-4 py-2 text-sm',
  md: 'px-6 py-3 text-base',
  lg: 'px-8 py-4 text-lg',
};

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  disabled = false,
  onClick,
  type = 'button',
  icon: Icon,
  iconRight: IconRight,
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`
        inline-flex items-center justify-center gap-2 font-semibold rounded-xl
        transform transition-all duration-200
        ${!disabled ? 'hover:scale-[1.02] active:scale-[0.98]' : ''}
        disabled:opacity-60 disabled:cursor-not-allowed disabled:transform-none
        ${variants[variant]}
        ${sizes[size]}
        ${className}
      `}
    >
      {Icon && <Icon className="w-5 h-5 flex-shrink-0" />}
      {children}
      {IconRight && <IconRight className="w-4 h-4 flex-shrink-0 group-hover:translate-x-1 transition-transform" />}
    </button>
  );
};

export default Button;
